"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToNearestHalfStar = exports.Stars = void 0;
const react_1 = __importDefault(require("react"));
const range_1 = __importDefault(require("lodash/range"));
const box_1 = require("../box");
const styles_1 = require("./styles");
const types_1 = require("./types");
const MAX_STARS = 5;
const Stars = (props) => {
    const { 'aria-label': ariaLabel, numStars = 0 } = props;
    const roundedNumStars = (0, exports.roundToNearestHalfStar)(numStars);
    const numFullStars = Math.floor(roundedNumStars);
    const numHalfStars = roundedNumStars % 1 !== 0 ? 1 : 0;
    const numEmptyStars = MAX_STARS - numFullStars - numHalfStars;
    const renderStars = (type, amount) => {
        return (0, range_1.default)(0, amount).map((index) => (react_1.default.createElement(box_1.Box, { item: true, key: index },
            react_1.default.createElement(styles_1.Star, { fill: type }))));
    };
    return (react_1.default.createElement(box_1.Box, { container: true, wrap: "nowrap", spacing: 1, "aria-label": ariaLabel },
        renderStars(types_1.StarFill.Full, numFullStars),
        renderStars(types_1.StarFill.Half, numHalfStars),
        renderStars(types_1.StarFill.Empty, numEmptyStars)));
};
exports.Stars = Stars;
const roundToNearestHalfStar = (numStars) => {
    if (numStars < 0 || isNaN(numStars)) {
        return 0;
    }
    else if (numStars > 5) {
        return 5;
    }
    return parseFloat((Math.round(numStars * 2) / 2).toFixed(1));
};
exports.roundToNearestHalfStar = roundToNearestHalfStar;
__exportStar(require("./types"), exports);
